export const API_URL = "https://netime.glitch.me/api/v1";
// export const API_URL = "http://localhost:3000/api/v1";
export const GITHUB_URL = "https://github.com/hoangvu12/Netime";
export const FACEBOOK_URL = "https://www.facebook.com/nguyenvuzxc1/";
export const DISCORD_NAME = "VuNguyen#5055";

export const GENRES = [
  { slug: "hanh-dong", name: "Hành Động" },
  { slug: "vien-tuong", name: "Viễn Tưởng" },
  { slug: "lang-man", name: "Lãng Mạn" },
  { slug: "kinh-di", name: "Kinh Dị" },
  { slug: "vo-thuat", name: "Võ Thuật" },
  { slug: "hai-huoc", name: "Hài Hước" },
  { slug: "truong-hoc", name: "Trường Học" },
  { slug: "trinh-tham", name: "Trinh Thám" },
  { slug: "am-nhac", name: "Âm Nhạc" },
  { slug: "phieu-luu", name: "Phiêu Lưu" },
  { slug: "sieu-nhien", name: "Siêu Nhiên" },
  { slug: "doi-thuong", name: "Đời Thường" },
  { slug: "gia-tuong", name: "Giả Tưởng" },
  { slug: "robot", name: "Robot" },
  { slug: "game", name: "Game" },
  { slug: "the-thao", name: "Thể Thao" },
  { slug: "kich-tinh", name: "Kịch Tính" },
];

export const RANKINGS = [
  {
    slug: "ngay",
    name: "BXH ngày",
  },
  {
    slug: "tuan",
    name: "BXH tuần",
  },
  {
    slug: "thang",
    name: "BXH tháng",
  },
  {
    slug: "nam",
    name: "BXH năm",
  },
];
